import Navbar from "../components/Navbar/Navbar";
import styles from "./Home.module.css";

import React from "react";

function Home() {

  return (
    <>
      <Navbar />
      <section className="mg-t-2 pd-2 formatted-text">
        <h2 className={styles.h2}>Recorded streams</h2>
      </section>
    </>
  );
}

export default Home;
